
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <div class="page-wrapper">

    <span class="back-button" (click)="returnToAccount()">
      <ion-icon name="arrow-back"></ion-icon>
      Back to account
    </span>

    <div class="middle-info">

      <div class="section-header">Business locations</div>

      <div *ngIf="businessLocations && !businessLocations.length" class="placeholder-text">
        <p>Add your first location, and set up bank accounts per location through Stripe.</p>
      </div>

      <div *ngFor="let location of businessLocations">
        <ion-item class="" lines="none">
          <ion-icon class="start-icon" slot="start" name="location-outline" color="green"></ion-icon>
          <ion-label>
            {{location.name}}
            <p>{{location.address.city}}, {{location.address.state}}</p>
          </ion-label>
          <p slot="end">
            <span *ngIf="!location.stripeAccountID">
              <span class="stripe-button" (click)="setUpStripe(location.id)">Activate Stripe</span>
              <span *ngIf="hasExistingStripeAccounts()"> |
                <span class="stripe-button" (click)="useExistingStripeAccount(location.id)">Use existing Stripe</span>
              </span>
            </span>
            <span class="stripe-button" *ngIf="location.stripeAccountID" (click)="viewStripe(location.id)">View Stripe account</span>
          </p>
        </ion-item>
      </div>

      <div class="submit-button" *ngIf="!addingLocation">
        <ion-button color="marine" (click)="addNewLocation()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">Add new location</ion-button>
      </div>

      <div [hidden]="!addingLocation" class="adding-payment">

        <div class="section-header">Add new location</div>

        <div>
          <ion-item class="booking-input" lines="none">
            <ion-input placeholder="Location name (Note: this will be public)" [(ngModel)]="locationFields.name" name="name" type="text" #name="ngModel"></ion-input>
          </ion-item>
          <ion-item lines="none" class="address-search">
            <input placeholder="Address" #addressInput ngx-google-places-autocomplete (onAddressChange)="handleAddressChange($event)"/>
            <ion-icon slot="start" name="pin"></ion-icon>
          </ion-item>
        </div>

        <div class="submit-button">
          <ion-button color="marine" (click)="submitNewLocation()" class="save-button SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">Save location</ion-button>

          <ion-button class="cancel-button" fill="clear" (click)="closeNewLocation()">
            Cancel
          </ion-button>
        </div>
      </div>

      <br><br>

    </div>

  </div>

</ion-content>